import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js"; // Import the encryption library
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  private SECRET_KEY = environment.secretKey;

  constructor() {}

  // Encrypt data
  private encryptData(data: any): string {
    try {
      return CryptoJS.AES.encrypt(
        JSON.stringify(data),
        this.SECRET_KEY
      ).toString();
    } catch (e) {
      console.error("Encryption error:", e);
      return null;
    }
  }

  // Decrypt data
  private decryptData(encryptedData: string): any {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.SECRET_KEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      console.error("Decryption error:", e);
      return null;
    }
  }

  // Set item with optional encryption
  setItem<T>(key: string, value: T, encrypt: boolean = false): void {
    try {
      const dataToStore = encrypt
        ? { encrypted: true, value: this.encryptData(value) }
        : { encrypted: false, value: JSON.stringify(value) };
      localStorage.setItem(key, JSON.stringify(dataToStore));
    } catch (e) {
      console.error("Error saving to localStorage", e);
    }
  }

  // Get item with automatic detection of encryption
  getItem<T>(key: string): T | null {
    try {
      const storedData = localStorage.getItem(key);
      if (storedData) {
        const parsedData = JSON.parse(storedData);

        if (parsedData.encrypted) {
          // Data is encrypted, decrypt it
          return this.decryptData(parsedData.value) as T;
        } else {
          // Data is not encrypted, return it as is
          return JSON.parse(parsedData.value) as T;
        }
      }
      return null;
    } catch (e) {
      console.error("Error reading from localStorage", e);
      return null;
    }
  }

  // Remove item
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all data
  clear(): void {
    localStorage.clear();
  }
}
